export default __webpack_public_path__ + "static/media/ava-ceo.5809fcd9.png";